import axios from "axios";
import qs from "qs";
import * as actionType from "../../../constant/actionType";

export const GenerateExpiryReport = (params = {}) => async () => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    
    // Normalize array parameters as JSON strings to match backend expectations
    const processedParams = { ...params };
    const arrayFields = [
      "client_org_ids",
      "provider_org_ids",
      "provider_type_ids",
      "provider_statuses",
      "states",
      "services",
      "document_type_ids"
    ];
    
    arrayFields.forEach(field => {
      if (processedParams[field]) {
        if (Array.isArray(processedParams[field])) {
          const ids = processedParams[field].map(item => {
            if (item && typeof item === "object") {
              return item.organisation_id ?? item.provider_type_id ?? item.state_id ?? item.document_type_id ?? item.id ?? item;
            }
            return item;
          });
          processedParams[field] = JSON.stringify(ids);
        } else if (typeof processedParams[field] === "string" && !processedParams[field].startsWith("[")) {
          processedParams[field] = JSON.stringify(processedParams[field].split(",").map(s => s.trim()).filter(Boolean));
        }
      }
    });

    const response = await axios({
      method: "get",
      url: `${actionType.environment_url}/api/admin/GenerateExpiryReport`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      params: processedParams,
      paramsSerializer: (payload) =>
        qs.stringify(payload, { arrayFormat: "repeat", skipNulls: true }),
    });

    return response.data;
  } catch (error) {
    return error?.response?.data ?? { success: false, message: error.message };
  }
};
